module.exports = "<p>\n  order response works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/api-response/api-response.component.html
// module id = ./src/app/api-response/api-response.component.html
// module chunks = main